module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.groupList,
      "height": _vm.wheight - 240
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "act_name",
      "label": "拼团名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品类型",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.group_goods_type == 'services') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("服务类商品")]) : _c('el-tag', [_vm._v("实体类商品")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goods_name",
      "label": "拼团商品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "拼团有效期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("datetime")(scope.row.begin_time, 'yyyy-MM-dd hh:mm:ss')) + " - " + _vm._s(_vm._f("datetime")(scope.row.end_time, 'yyyy-MM-dd hh:mm:ss')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "act_price",
      "label": "拼团价格",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.cursymbol + scope.row.act_price / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "disabled",
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.activity_status == 1) ? _c('span', [_vm._v("未开始")]) : (scope.row.activity_status == 2) ? _c('span', [_vm._v("进行中")]) : _c('span', [_vm._v("已结束")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              return _vm.showGroupsActivityDataAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("活动数据\n        ")]), _vm._v(" "), (scope.row.activity_status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              return _vm.editGroupsAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n        ")]) : _vm._e(), _vm._v(" "), (scope.row.activity_status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showGroupsAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看\n        ")]) : _vm._e(), _vm._v(" "), (scope.row.activity_status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.finishGroupsAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("终止\n        ")]) : _vm._e(), _vm._v(" "), (scope.row.activity_status == 1 || scope.row.activity_status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGroupsAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删 除\n        ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d92ab5a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d92ab5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/groups/list/groupsList.vue
// module id = 2517
// module chunks = 0